var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-box",style:(_vm.show?'bottom: 0%':'bottom: -40%')},[_c('van-area',{attrs:{"show":_vm.show,"area-list":_vm.areaList},on:{"confirm":_vm.confirmAddr,"cancel":_vm.cancelAddr}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f8e0d2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/address/selectAddress.vue
// module id = null
// module chunks = 